import React, { useState } from "react";
import "yet-another-react-lightbox/styles.css";
import "./imageGallery.scss";
import { realizationsData } from "../realizations";
import Lightbox from "yet-another-react-lightbox";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Counter from "yet-another-react-lightbox/plugins/counter";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import "yet-another-react-lightbox/plugins/counter.css";
import { Magnifying } from "../../../icons";

const ImageGallery: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);

  const openGallery = (idx: number) => {
    setIndex(idx);
    setOpen(true);
  };

  return (
    <section className="imageGallery">
      <div className="imageGallery__container">
        <header className="imageGallery__header">
          <div className="imageGallery__header-top">
            <span className="imageGallery__header-line" />
            <span className="imageGallery__eyebrow">GALERIA ZDJĘĆ</span>
            <span className="imageGallery__header-line" />
          </div>
          <h2 className="imageGallery__title">Nasze Realizacje i Projekty</h2>
          <p className="imageGallery__description">
            Zobacz wybrane efekty naszych prac wykończeniowych, remontowych oraz
            aranżacji wnętrz. Kliknij w dowolne zdjęcie, aby powiększyć i
            przejrzeć pełną galerię.
          </p>
        </header>

        {/* Gallery Grid */}
        <div className="imageGallery__grid">
          {realizationsData.map((item, i) => (
            <button
              key={item.id}
              className="imageGallery__card"
              onClick={() => openGallery(i)}
              aria-label={`Powiększ zdjęcie`}
            >
              <div className="imageGallery__image-wrapper">
                <img
                  src={item.image}
                  alt={item.image}
                  className="imageGallery__image"
                  loading="lazy"
                />
                <div className="imageGallery__overlay" />
                <div className="imageGallery__zoom-icon">
                  <Magnifying />
                </div>
              </div>
            </button>
          ))}
        </div>

        {/* Lightbox Modal */}
        <Lightbox
          open={open}
          close={() => setOpen(false)}
          index={index}
          carousel={{
            preload: 10,
          }}
          on={{
            view: ({ index: newIdx }) => setIndex(newIdx),
          }}
          plugins={[Thumbnails, Counter]}
          counter={{ container: { style: { bottom: "unset", top: 0 } } }}
          slides={realizationsData.map((item) => ({
            src: item.image,
          }))}
          render={{
            thumbnail: ({ slide, rect }) => {
              const slideIndex = realizationsData.findIndex(
                (item) => item.image === slide.src,
              );
              return (
                <div
                  className={
                    slideIndex === index
                      ? "my-active-thumbnail"
                      : "my-thumbnail"
                  }
                  style={{ width: rect.width, height: rect.height }}
                >
                  <img
                    src={slide.src}
                    alt=""
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </div>
              );
            },
          }}
        />
      </div>
    </section>
  );
};

export default ImageGallery;
